module.exports = "/avatar-deleted-profile-cc5400484495e5e8fab514471b968299.svg";